import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {L10nModule} from '../../../components/translate';
import {OrderTotalBlockComponent} from './order-total-block.component';

@NgModule({
    imports: [
        CommonModule,
        L10nModule
    ],
    declarations: [
        OrderTotalBlockComponent
    ],
    exports: [
        OrderTotalBlockComponent
    ]
})
export class OrderTotalBlockModule {}
